module.exports = "/assets/998fdf83f586bfe81b4b204f0c84a907.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5G.png
// module id = 1058
// module chunks = 0